type CaseTypeMap = {
    [key: string]: {
        [key: string]: {
            caseType: string;
            caseSubType: string;
        }
    }
};

// This maps the (caseType, caseSubType) that we have on AE portal to actual (caseType, caseSubType) in DynamoDB
//example here is (Abuse, BWND) on AE portal -> (BWND, BWND) in DDB
export const CASE_TYPE_OVERRIDE_MAPPING: CaseTypeMap = {
    'Abuse': {
        'BWND': {
            caseType: 'BWND',
            caseSubType: 'BWND'
        }
    }
} as const;

export type { CaseTypeMap };